<template>
    <div class="sb-loading" :class="`sb-color-${variant}`" :style="{width: `${size}px`}"><div v-for="n in 30" :key="n"></div></div>
</template>
<script>
export default {
    props: { size: { type: Number, default: 80 }, variant: { type: String, default: 'primary'} }
}
</script>
<style lang="scss">
$total-time: 1.2s; // Tempo total da animação
$circle-count: 12; // Máximo: 30, mínimo recomendado: 3
$delay-per-circle: ($total-time / $circle-count); // Tempo de delay para sincronizar as animações
.sb-loading {
    display: block;
    position: relative;
    aspect-ratio: 1;
    border-radius: 50%;
    overflow: hidden;
    div { // Container que posiciona o círculo
        position: absolute;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 5%;
        &::after { // Círculo
            display: block;
            width: 5%;
            height: 5%;
            margin: 0 auto;
            background-color: currentColor;
            border-radius: 50%;
            animation: loading-circles $total-time linear infinite;
        }
        @for $i from 1 through $circle-count {
            &:nth-child(#{$i}) {
                &::after {
                    content: ''; // Garante que somente a quantidade de círculos escolhida estará visível
                    animation-delay: $delay-per-circle * ($i - 1); // Sincroniza o tempo entre as animações. Pode ser aumentado ou reduzido para ter outros comportamentos
                }
                transform: rotate((360 / $circle-count) * ($i - 1) * 1deg); // Não é recomendado mudar, mas o '360' pode ser alterado para criar um semicírculo
            }
        }
    }
}
@keyframes loading-circles {
    // Alterar os intervalos faz com que os círculos cresçam/diminuam mais rápido/devagar
    // Forma base
    0%,90%,100% {
        transform: scale(1);
        opacity: .5;
    }
    // Forma destacada
    20% {
        transform: scale(2);
        opacity: 1;
    }
}
</style>